import React, {useMemo} from 'react';
import {Link} from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import OurTeam from './OurTeam';
import CtaBand from './CtaBand';
import usePageMeta, {breadcrumbJsonLd} from '../seo/usePageMeta';
import './Pages.css';

const Team = () => {
  const jsonLd = useMemo(
    () => breadcrumbJsonLd([{name: 'Startseite', path: '/'}, {name: 'Team', path: '/team'}]),
    []
  );

  usePageMeta({
    title: 'Unser Team | Cura Care Pflegedienst Eitorf',
    description:
      'Lernen Sie die Leitung von Cura Care kennen: Pflegewissenschaftlerin M. Sc., Pflegedienstleitung, Palliativ-Fachkräfte und Wundexpertin in Eitorf.',
    path: '/team',
    jsonLd
  });

  return (
    <div className="page-view">
      <Header />
      <main className="page" id="team">
        <div className="page__inner">
          <section className="page-section">
            <nav className="breadcrumb" aria-label="Brotkrumen">
              <Link to="/">Startseite</Link>
              <span aria-hidden="true">/</span>
              <span>Team</span>
            </nav>
            <div className="page__header">
              <p className="kicker">Menschen, die Cura Care prägen</p>
              <h1>Unser Team</h1>
              <p>
                Lernen Sie die Menschen kennen, die Cura Care mit Fachwissen, Empathie und Herzblut prägen.
              </p>
            </div>
          </section>
        </div>
        <OurTeam />
      </main>
      <CtaBand />
      <Footer />
    </div>
  );
};

export default Team;
